import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'
import { AutopilotPlansModal } from 'components/Settings/Workspace/AutopilotPlans/AutopilotPlansModal'
import { useCampaignsFeatureFlag } from './useCampaignsFeatureFlag'

/**
 * Creates a function that either opens the autopilot plans modal or
 * the action desired based on whether the user has access to paid features
 *
 * @param fn - The function to call if the user has access
 * @returns A function with the same signature as the input function
 */
export const useAutopilotUpgradeGuard = <T extends (...args: any[]) => any>(fn?: T): T => {
  const workspace = useCurrentWorkspace()
  const { openModal } = useModals()
  const tierUsageStore = useRootStore().tierUsageStore
  const { currentSubscription } = tierUsageStore
  const isCampaignsEnabled = useCampaignsFeatureFlag()

  const showAutopilotPlans =
    isCampaignsEnabled &&
    workspace?.is_virtual_marketer &&
    currentSubscription?.plan &&
    [PaymentPlanKey.Free, PaymentPlanKey.BlazeAutopilotStarter].includes(currentSubscription?.plan)

  if (!fn) {
    return (() => undefined) as T
  }

  return ((...args: Parameters<T>) => {
    if (showAutopilotPlans) {
      openModal(AutopilotPlansModal)
      return
    }

    return fn(...args)
  }) as T
}
